import {
  DocumentReference,
  isDocRef,
  TypeGuard,
} from '@principle-theorem/shared';
import { isString } from 'lodash';
import { IInvoice } from '../../../invoice/invoice';
import { MohClaimType } from '../../moh/moh';
import { ITransaction } from '../../transaction';
import { IFundingRequest } from '../funding-request';
import { IMohPreApprovalFundingRequest } from './moh-pre-approval';
import { IMohExtendedData } from '../../moh/moh-extended-data';

export interface IMohClaimFundingRequestData {
  claimUid: string;
  invoiceRef: DocumentReference<IInvoice>;
  transactionRef?: DocumentReference<ITransaction<IMohExtendedData>>;
  claimType?: MohClaimType;
  approvalRequestRef?: DocumentReference<IMohPreApprovalFundingRequest>;
  approvalNumber?: string;
  individualTreatmentFormPath?: string;
  claimSummaryFormPath?: string;
  signaturePath?: string;
}

export type IMohClaimFundingRequest =
  IFundingRequest<IMohClaimFundingRequestData>;

export const isMohClaimFundingRequestData =
  TypeGuard.interface<IMohClaimFundingRequestData>({
    claimType: TypeGuard.enumValue(MohClaimType),
    claimUid: isString,
    approvalRequestRef: TypeGuard.nilOr(isDocRef),
    approvalNumber: TypeGuard.nilOr(isString),
    individualTreatmentFormPath: TypeGuard.undefinedOr(isString),
    claimSummaryFormPath: TypeGuard.undefinedOr(isString),
    signaturePath: TypeGuard.undefinedOr(isString),
    invoiceRef: TypeGuard.undefinedOr(isDocRef),
    transactionRef: TypeGuard.undefinedOr(isDocRef),
  });
